<template>
  <Card padding-less outlined>
    <Row class="align-center px-9 py-5">
      <Col cols="12 col-md-8">
        <FaviconHeading />
        <FaviconSpecifications />
        <StepByStep class="mt-0" />
      </Col>
      <Col class="align-self-end mb-10" cols="12 col-sm-12 col-md-4">
        <FaviconBox :src="faviconUrl" @onSuccess="fetchFavicon" v-if="faviconUrl" />
        <UploadFavicon @onSuccess="fetchFavicon" v-else />
      </Col>
    </Row>
  </Card>
</template>

<script>
import { computed, onMounted } from 'vue'
import { Card, Row, Col, useLocale, useVueRouter } from '@locaweb/design-system-vue'
import { useFavicon } from '@/composables/api/useFavicon'
import StepByStep from './FaviconCard/StepByStep.vue'
import FaviconBox from './FaviconCard/FaviconBox.vue'
import UploadFavicon from './FaviconCard/UploadFavicon.vue'
import FaviconHeading from './FaviconCard/FaviconHeading.vue'
import FaviconSpecifications from './FaviconCard/FaviconSpecifications.vue'

export default {
  name: 'FaviconCard',
  components: {
    StepByStep,
    FaviconBox,
    UploadFavicon,
    FaviconHeading,
    FaviconSpecifications,
    Card,
    Row,
    Col
  },
  setup () {
    const lc = useLocale('site.favicon.faviconCard')
    const { data, execute: executeFetch } = useFavicon()
    const { $route } = useVueRouter()
    const grayText = 'gray--text text--scale500 text-paragraph-2'

    const faviconUrl = computed(() => data?.value?.faviconUrl)
    const siteId = computed(() => $route.params.siteId)

    const fetchFavicon = async () => {
      await executeFetch({ id: siteId.value })
    }

    onMounted(async () => await fetchFavicon())

    return { lc, faviconUrl, grayText, fetchFavicon }
  }
}
</script>
